import { Component, OnInit } from '@angular/core';
import * as Constants from '../../../assets/constants/Constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  test : Date = new Date();
  C = Constants;

  constructor() { }

  ngOnInit() {
  }

}
